export enum DynamicContentHeaderType {
  BigTextHeader = 'bigTextHeader',
  SmallImageHeader = 'smallImageHeader',
}
